// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"a1a76b79","689":"e99ad4a2","695":"7588d84a"}[chunkId] + ".chunk.js";
};